var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvisibleFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1194_9523",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4725 0.762573H0V24.7364H23.4725V0.762573Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1194_9523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7362 3.75928C17.0097 3.75928 21.3971 7.63505 22.3175 12.7495C21.3981 17.8639 17.0097 21.7397 11.7362 21.7397C6.46275 21.7397 2.07535 17.8639 1.15503 12.7495C2.07437 7.63505 6.46275 3.75928 11.7362 3.75928ZM11.7362 19.7418C13.7309 19.7414 15.6663 19.0494 17.2257 17.7792C18.7852 16.5089 19.8762 14.7356 20.3203 12.7495C19.8746 10.7649 18.7828 8.99357 17.2236 7.72498C15.6643 6.45639 13.7298 5.76562 11.7362 5.76562C9.74274 5.76562 7.80821 6.45639 6.24894 7.72498C4.68966 8.99357 3.5979 10.7649 3.15215 12.7495C3.59627 14.7356 4.68733 16.5089 6.24675 17.7792C7.80618 19.0494 9.7416 19.7414 11.7362 19.7418ZM11.7362 17.2446C10.569 17.2446 9.44957 16.771 8.6242 15.928C7.79884 15.085 7.33515 13.9417 7.33515 12.7495C7.33515 11.5573 7.79884 10.4139 8.6242 9.57096C9.44957 8.72797 10.569 8.25437 11.7362 8.25437C12.9035 8.25437 14.0229 8.72797 14.8483 9.57096C15.6737 10.4139 16.1373 11.5573 16.1373 12.7495C16.1373 13.9417 15.6737 15.085 14.8483 15.928C14.0229 16.771 12.9035 17.2446 11.7362 17.2446ZM11.7362 15.2467C12.3847 15.2467 13.0066 14.9836 13.4652 14.5153C13.9237 14.047 14.1813 13.4118 14.1813 12.7495C14.1813 12.0872 13.9237 11.452 13.4652 10.9836C13.0066 10.5153 12.3847 10.2522 11.7362 10.2522C11.0878 10.2522 10.4659 10.5153 10.0073 10.9836C9.5488 11.452 9.29119 12.0872 9.29119 12.7495C9.29119 13.4118 9.5488 14.047 10.0073 14.5153C10.4659 14.9836 11.0878 15.2467 11.7362 15.2467Z",
    fill: "#0095DA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvisibleFill);
export default __webpack_public_path__ + "static/media/invisible-fill.a4f6fe52c87d7cbd65b9739b05806c44.svg";
export { ForwardRef as ReactComponent };